import { getRandomInt } from '@/utilities';
import Task from '@/models/Task';
import Bug from '@/models/Task/Bug';

export default class Feature extends Task {
  constructor({ product, parentTask, hasSpec = false }) {
    super({ product, parentTask });
    this.remainingTime = this.getBaseTime();
    this.hasSpec = hasSpec;
  }

  get progress() {
    return this.isFinished ? 1 : 0;
  }

  get subtaskHasBug() {
    if (this.subTasks.length === 0) {
      return 0;
    }
    return this.subTasks.find((bug) => !bug.isVerified) ? 1 : 0;
  }

  // eslint-disable-next-line class-methods-use-this
  getBaseTime() {
    return getRandomInt(1, 3);
  }

  generateSubTasks() {
    if (getRandomInt(1, 10) > 2) {
      const random = getRandomInt(1, 3);
      // 沒辦法保證 task 做的是對的
      return super.generateTasks({
        TypeClass: Bug,
        product: this.product,
        count: random,
      });
    }
    return [];
  }
}
